
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-admissions-detail",
      function () {
        return require("private-next-pages/news-admissions-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-admissions-detail"])
      });
    }
  